// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import ReactDOM from 'react-dom'

import Spinner from '../../Spinner'

import './index.css'

const SpinnerPortal = () => {
  return ReactDOM.createPortal(
    <div>
      <Spinner/>
    </div>,
    document.getElementById('spinner-modal')
  )
}

export default SpinnerPortal
